<template>
   <div class="test-form">
      <Modal 
         :show="show" 
         :loading="loading" 
         :icon="User.forms.add_user.icon" 
         :title="User.forms.add_user.title" 
         :subtitle="User.forms.add_user.subtitle" 
         @close="$store.commit('show',false)"
         @submit="addUser({ref: $refs[User.forms.add_user.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="User.forms.add_user.name" 
               :forms="User.forms.add_user.forms" 
               :form_data="User.forms.add_user.data"
            />
         </template>
      </Modal>

      <Modal 
         :show="showEdit" 
         :loading="loading" 
         :icon="User.forms.edit_user.icon" 
         :title="User.forms.edit_user.title" 
         :subtitle="User.forms.edit_user.subtitle" 
         button="Save"
         @close="$store.commit('showEdit',false)"
         @submit="editUser({ref: $refs[User.forms.edit_user.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="User.forms.edit_user.name" 
               :forms="User.forms.edit_user.forms" 
               :formData="User.forms.edit_user.data"
            />
         </template>
      </Modal>

      <Table 
         :icon="User.tables.users.icon" 
         :table_fields="User.tables.users.table_fields" 
         :table_data="users" 
         :title="User.tables.users.title" 
         :search_fields="User.tables.users.search_fields"
         :row_data="User.tables.users.row_data"
         @on-action="handleActions"
      />
   </div>
</template>

<script>
import user from "../rsc/stores/user.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('user')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('user',user,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: 'User Actions',
            actions: [
               {
                  title: 'Add User',
                  icon: 'fa-users',
                  event: 'action:create_user',
                  payload: {
                     name: 'create_user'
                  }
               }
            ]
         })
      },500);

      EventBus.$on("action:create_user", payload => {
         if(payload.name === 'create_user'){
            this.$store.commit('show', true)
         }
      });
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'User',
         'users',
         'showEdit',
         'selectedUser',
         'show',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'fetchFormData',
         'fetchUsers',
         'addUser',
         'editUser',
         'deleteUser',
      ]),
      async handleActions(payload){
         if(payload.action === 'user:delete'){
            await this.deleteUser(payload.row._id)
         }else if(payload.action === 'user:edit'){
            let names = payload.row.names.split(' '), firstName = names[0]
            delete names[0]
            let Model = this.User
            Model.forms.edit_user.data = {
               firstName: firstName,
               lastName: names.join(' '),  
               role: payload.row.role,
            }
            this.$store.commit('User',Model)
            this.$store.commit('selectedUser',payload.row)
            this.$store.commit('showEdit',true)
         }
      },
   },
   async mounted(){
      utils.registerModule('user',user,this.$store)
      // await this.fetchFormData()
      await this.fetchUsers()
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>